module.exports = __webpack_public_path__ + "static/media/dante.44188389.jpeg";